import { ItemConfig } from './types'

const CM_PX = 78.7

const sizes = {
  S: 0.846,
  M: 0.897,
  L: 0.948,
  XL: 1,
}

// TODO: Add 2 bottom sections on front and back
export const UA_500101_TSHIRT_CONFIG: ItemConfig = {
  name: 'United Athle 5.6oz Tシャツ',
  vendor: 'キャブ',
  vendor_code: '500101',
  printable_sections: ['103', '105'],
  colors: [
    { name: 'ホワイト', hex: '#FFFFFF', system_id: '001', item_id: 51 },
    { name: 'アッシュ', hex: '#FFFFFF', system_id: '005', item_id: 51 },
    { name: 'ナチュラル', hex: '#FFFFFF', system_id: '019', item_id: 51 },
    { name: 'ライトベージュ', hex: '#FFFFFF', system_id: '053', item_id: 51 },
    { name: 'Ｌイエロー', hex: '#FFFFFF', system_id: '487', item_id: 51 },
    { name: 'Ｌブルー', hex: '#FFFFFF', system_id: '488', item_id: 51 },
    { name: 'ベビーピンク', hex: '#FFFFFF', system_id: '576', item_id: 51 },
    { name: 'ブラック', hex: '#FFFFFF', system_id: '002', item_id: 53 },
    { name: 'ミックスグレー', hex: '#FFFFFF', system_id: '006', item_id: 53 },
    { name: 'チャコール', hex: '#FFFFFF', system_id: '007', item_id: 53 },
    { name: 'Ｌ　グレー', hex: '#FFFFFF', system_id: '010', item_id: 53 },
    { name: 'イエロー', hex: '#FFFFFF', system_id: '021', item_id: 53 },
    { name: 'ゴールド', hex: '#FFFFFF', system_id: '022', item_id: 53 },
    { name: 'ミントグリーン', hex: '#FFFFFF', system_id: '024', item_id: 53 },
    { name: 'グリーン', hex: '#FFFFFF', system_id: '029', item_id: 53 },
    { name: 'シティグリーン', hex: '#FFFFFF', system_id: '035', item_id: 53 },
    { name: 'メロン', hex: '#FFFFFF', system_id: '037', item_id: 53 },
    { name: 'Ｄ　ブラウン', hex: '#FFFFFF', system_id: '052', item_id: 53 },
    { name: 'オレンジ', hex: '#FFFFFF', system_id: '064', item_id: 53 },
    { name: 'ピンク', hex: '#FFFFFF', system_id: '066', item_id: 53 },
    { name: 'レッド', hex: '#FFFFFF', system_id: '069', item_id: 53 },
    { name: 'バーガンディ', hex: '#FFFFFF', system_id: '072', item_id: 53 },
    { name: 'ラベンダー', hex: '#FFFFFF', system_id: '076', item_id: 53 },
    { name: 'マット　パープル', hex: '#FFFFFF', system_id: '079', item_id: 53 },
    { name: 'サックス', hex: '#FFFFFF', system_id: '082', item_id: 53 },
    { name: 'アクアブルー', hex: '#FFFFFF', system_id: '083', item_id: 53 },
    { name: 'ロイヤルブルー', hex: '#FFFFFF', system_id: '085', item_id: 53 },
    { name: 'ネイビー', hex: '#FFFFFF', system_id: '086', item_id: 53 },
    { name: 'インディゴ', hex: '#FFFFFF', system_id: '087', item_id: 53 },
    { name: 'スレート', hex: '#FFFFFF', system_id: '088', item_id: 53 },
    { name: 'ＢＡＮＡＮＡ', hex: '#FFFFFF', system_id: '369', item_id: 53 },
    { name: 'アイビーグリーン', hex: '#FFFFFF', system_id: '497', item_id: 53 },
    { name: 'ＣＡＬオレンジ', hex: '#FFFFFF', system_id: '498', item_id: 53 },
    { name: 'サンドカーキ', hex: '#FFFFFF', system_id: '537', item_id: 53 },
    { name: 'ターコイズブルー', hex: '#FFFFFF', system_id: '538', item_id: 53 },
    {
      name: 'バイオレットパープル',
      hex: '#FFFFFF',
      system_id: '539',
      item_id: 53,
    },
    { name: 'アプリコット', hex: '#FFFFFF', system_id: '574', item_id: 53 },
  ],
  sizes: ['S', 'M', 'L', 'XL'],
  sections: [
    {
      name: '胸中央',
      id: '103',
      config: {
        width: 2518,
        height: 2991,
      },
    },
    {
      name: '左胸',
      id: '101',
      config: {
        width: 787,
        height: 787,
      },
    },
    {
      name: '右胸',
      id: '102',
      config: {
        width: 787,
        height: 787,
      },
    },
    {
      name: '背中中央',
      id: '105',
      config: {
        width: 2518,
        height: 2991,
      },
    },
    {
      name: '襟下',
      id: '109',
      config: {
        width: 787,
        height: 787,
      },
    },
    {
      name: '左袖',
      id: '107',
      config: {
        width: 787,
        height: 787,
      },
    },
    {
      name: '右袖',
      id: '108',
      config: {
        width: 787,
        height: 787,
      },
    },
  ],
  sides: [
    {
      name: 'front',
      width: 7200,
      height: 7200,
      origin: { x: 7200 / 2, y: 7200 * 0.17 },
      sizes: sizes,
      sections: [
        {
          id: '103',
          offset: {
            x: -(2518 / 2),
            y: 5 * CM_PX,
          },
        },
        {
          id: '101',
          offset: {
            x: 5 * CM_PX,
            y: 6 * CM_PX,
          },
        },
        {
          id: '102',
          offset: {
            y: 6 * CM_PX,
            x: -(5 * CM_PX + 787),
          },
        },
      ],
    },
    {
      name: 'back',
      width: 7200,
      height: 7200,
      origin: { x: 7200 / 2, y: 7200 * 0.12 },
      sizes: sizes,
      sections: [
        {
          id: '105',
          offset: {
            x: -(2518 / 2),
            y: 5 * CM_PX,
          },
        },
        {
          id: '109',
          offset: {
            x: -(787 / 2),
            y: 2.5 * CM_PX,
          },
        },
      ],
    },
    {
      name: 'left',
      width: 2620,
      height: 3494,
      origin: { x: 2620 / 2, y: 3494 * 0.84 },
      sizes: sizes,
      sections: [
        {
          id: '107',
          offset: {
            y: -(2 * CM_PX + 787),
            x: -(787 / 2),
          },
        },
      ],
    },
    {
      name: 'right',
      width: 2620,
      height: 3494,
      origin: { x: 2620 / 2, y: 3494 * 0.84 },
      sizes: sizes,
      sections: [
        {
          id: '108',
          offset: { y: -(2 * CM_PX + 787), x: -(787 / 2) },
        },
      ],
    },
  ],
}
